import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { forgetPassword, getSettings } from "../store/actions";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { settings } = useSelector((state) => state.settings);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  const onSubmit = (data) => {
    localStorage.setItem("email", data.email);
    dispatch(forgetPassword({ data, navigate, toast }));
  };

  return (
    <>
      <div className="login-wrp">
        <div className="login--inner">
          <div className="login-logo">
            <img src={settings?.logo} alt="" />
          </div>
          <div className="login-data">
            <h3>نسيت كلمة المرور!</h3>
            <p>برجاء ادخال البريد الالكتروني</p>
          </div>
          <div className="login-form">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <div>
                  <svg
                    width="22"
                    height="16"
                    viewBox="0 0 22 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.8228 0.933594L21.0728 0.183594H1.57275L0.822754 0.933594V14.4336L1.57275 15.1836H21.0728L21.8228 14.4336V0.933594ZM20.3228 2.48609V13.6836H2.32275V2.48759L10.8578 9.03359H11.7728L20.3228 2.48609ZM3.77775 1.68359H18.8678L11.3228 7.48709L3.77775 1.68359Z"
                      fill="#57338c"
                    />
                  </svg>

                  <input
                    {...register("email", { required: true })}
                    className="form-control"
                    placeholder="البريد الإلكتروني"
                  />
                </div>
                {errors.email && (
                  <p className="text-danger">البريد الالكتروني مطلوب</p>
                )}
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-blue">
                  ارسال
                </button>
              </div>
              <div className="form-group">
                <p className="back">
                  <NavLink to="/login">العودة لتسجيل الدخول</NavLink>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
